<template>
  <Bar :chart-data="chartData" :chart-options="chartOptions" :styles="styles" />
</template>

<script>
import { Bar } from 'vue-chartjs'
import Chart from 'chart.js/auto'

export default {
      components: {
        Bar
      },
      props: {
            chartdata: {
                  type: Object,
                  default: null
            },
            options: {
                  type: Object,
                  default: null
            },
            colors: {
                  type: Array
            },
            styles: {
                  type: Object,
                  default: () => {}
            }
      },
      data() {
            let extendedOptions = structuredClone(this.options)
            let extendedChartData = structuredClone(this.chartdata)
            extendedOptions.scales.y.stacked = true
            extendedOptions.plugins.tooltip.xAlign = 'left'
            extendedOptions.plugins.tooltip.yAlign = 'bottom'
            extendedOptions.onHover = function(event, activeElements) {
              clearTimeout(this.timeout)
              let elements = []
              if (activeElements[0]) {
                extendedChartData.datasets[activeElements[0].datasetIndex].data.forEach((v, i )=>{
                  elements.push({
                    datasetIndex: activeElements[0].datasetIndex,
                    index: i
                  })
                })
              }
              this.timeout = setTimeout(() => {
                this.setActiveElements(elements)
                this.update()
              }, 50)
            }
            extendedOptions.responsive = true
            extendedOptions.indexAxis = 'y'
            extendedOptions.maintainAspectRatio = false
            Chart.defaults.elements.bar.borderWidth = 0

            extendedChartData.datasets.forEach((v) => v.hoverBackgroundColor = '#FF0000')
            extendedChartData.datasets.forEach((v, i) => v.backgroundColor = this.colors[i % this.colors.length])
            return {
              chartData: extendedChartData,
              chartOptions: extendedOptions,
            }
      }
}
</script>